export default "/etc.clientlibs/pg/clientlibs/clientlib-site/resources/images/97b922a7695b09ed62103f1cf545e413.svg";